export default "__VITE_ASSET__c9775944__"